import { render, staticRenderFns } from "./goodsTypeCascader.vue?vue&type=template&id=65fea918&"
import script from "./goodsTypeCascader.vue?vue&type=script&lang=js&"
export * from "./goodsTypeCascader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports